export const API_URL = "http://localhost:8000/api";
export const IMG_URL = "http://localhost:8000/";
